import PropTypes from "prop-types"
import React from "react"
import Typography from "@material-ui/core/Typography"

export const ALERT_INFO = "alert-info"
export const ALERT_SUCCESS = "alert-success"
export const ALERT_ERROR = "alert-error"

const Alert = ({ message, type }) => (
   <div className={`alert ${type}`}>
       <Typography variant="body2" component="p">
           {message}
       </Typography>
   </div>
)

Alert.propTypes = {
    message: PropTypes.string,
    type: PropTypes.oneOf([
        "alert-info",
        "alert-success",
        "alert-error",
    ]),
}

export default Alert